import { DateTime } from "luxon";

export interface AvailableTimeSlotsProps {
  availableTimeSlots: any[];
  selectedTime: string | null;
  handleSelectedTime: (time: string) => void;
  merchantColor: string;
}

export const AvailableTimeSlots = ({
  availableTimeSlots,
  selectedTime,
  handleSelectedTime,
  merchantColor,
}: AvailableTimeSlotsProps) => {
  if (availableTimeSlots) {
    if (availableTimeSlots.length > 0) {
      return (
        <div className="grid grid-cols-3 gap-4">
          {availableTimeSlots.map((timeslot: any, index: any) => {
            const formattedTime = DateTime.fromFormat(
              timeslot.startTime,
              "HH:mm"
            ).toLocaleString(DateTime.TIME_SIMPLE);

            return (
              <button
                style={
                  selectedTime === timeslot.startTime
                    ? { backgroundColor: merchantColor }
                    : {}
                }
                data-testid="time-slot"
                key={index}
                className={`py-2 px-4 h-[44px] rounded-md border border-[#727272] ${
                  selectedTime === timeslot.startTime
                    ? "bg-black text-white"
                    : "bg-white text-black hover:bg-gray-300"
                } w-full text-[14px] font-medium`}
                onClick={() => handleSelectedTime(timeslot.startTime)}
              >
                {formattedTime}
              </button>
            );
          })}
        </div>
      );
    } else {
      return (
        <div>
          <p className="w-full font-normal text-[16px] text-[#727272]">
            There are no appointments available.{" "}
          </p>
        </div>
      );
    }
  }
};
